import { render, staticRenderFns } from "./CamStreamsTab.vue?vue&type=template&id=a573210a&scoped=true"
import script from "./CamStreamsTab.vue?vue&type=script&lang=js"
export * from "./CamStreamsTab.vue?vue&type=script&lang=js"
import style0 from "./CamStreamsTab.vue?vue&type=style&index=0&id=a573210a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a573210a",
  null
  
)

export default component.exports